import { Pipe, PipeTransform } from '@angular/core';

interface GroupWithProperties {
    uuid: string;
    name: string;
    isDefault?: boolean;
    isUnassigned?: boolean;
}

@Pipe({
    name: 'filterGroups'
})
export class FilterGroupsPipe implements PipeTransform {
    // Default and Unassigned UUIDs
    private readonly QRA_DEFAULT_GROUP_UUID = "00000000-0000-0000-0000-000000000001";
    private readonly UNASSIGNED_ACCESS_GROUP_UUID = "00000000-0000-0000-0000-000000000002";
  
    transform(groups: GroupWithProperties[], filterType: 'default' | 'unassigned' | 'regular'): GroupWithProperties[] {
        if (!groups || groups.length === 0) {
            return [];
        }
      
        switch(filterType) {
            case 'default':
                return groups.filter(group => 
                    group.isDefault || 
                    group.uuid === this.QRA_DEFAULT_GROUP_UUID ||
                    group.name === 'QRA Default'
                );
              
            case 'unassigned':
                return groups.filter(group => 
                    group.isUnassigned || 
                    group.uuid === this.UNASSIGNED_ACCESS_GROUP_UUID ||
                    group.name === 'Unassigned'
                );
              
            case 'regular':
                return groups.filter(group => 
                    (!group.isDefault && !group.isUnassigned) && 
                    group.uuid !== this.QRA_DEFAULT_GROUP_UUID && 
                    group.uuid !== this.UNASSIGNED_ACCESS_GROUP_UUID &&
                    group.name !== 'QRA Default' &&
                    group.name !== 'Unassigned'
                ).sort((a, b) => a.name.localeCompare(b.name));
            
            default:
                return groups;
        }
    }
}